<div class="p-dialog-header px-0">
  <div class="m-0 bold d-flex align-items-center dialog-gap">
    <i class="fs-4 pi pi-user-edit"></i>
    <span class="modal-title">Manage Borrowers</span>
  </div>
  <div class="p-dialog-header-actions">
    <button pButton type="button" size="large" (click)="reject()">
      <span pButtonIcon class="pi pi-times"></span>
    </button>
  </div>
</div>
<div class="content" cdkDropListGroup #dragContainer>
  @for (message of errorMessages; track message.detail) {
    <p-message [closable]="false" class="w-100 mb-3" severity="error">
      {{ message.detail }}
    </p-message>
  }
  <div class="d-flex flex-row align-items-center py-3 fw-bold">
    <h5 class="m-0">Move borrowers to split or merge</h5>
  </div>
  <div class="application-container brand-scrollbar" cdkScrollable>
    @for (app of activeApplications; track app; let appIndex = $index) {
      <div class="application-card pt-1 my-1">
        <div class="header">Application {{ appIndex + 1 }}</div>
        <div
          class="content"
          cdkDropList
          cdkDropListLockAxis="y"
          [cdkDropListData]="app.id"
          (cdkDropListDropped)="onBorrowerDroppedInApplication($event)"
          (cdkDropListEntered)="onBorrowerEnteredApplication($event)"
          (cdkDropListExited)="onBorrowerExitedApplication($event)"
          (cdkDropListSorted)="onBorrowerMovingIntoPosition($event)"
        >
          @for (borrower of borrowersByApp(app.id); track borrower) {
            @if (borrower.displayOrder === 0) {
              <div
                cdkDrag
                [cdkDragPreviewContainer]="'global'"
                [cdkDragBoundary]="dragContainerRef()"
                (cdkDragStarted)="onBorrowerDragStarted($event)"
                (cdkDragDropped)="onBorrowerDragDropped($event)"
                (cdkDragEnded)="onBorrowerDragEnded($event)"
                (cdkDragEntered)="onBorrowerDragEntered($event)"
                (cdkDragExited)="onBorrowerDragExited($event)"
                (cdkDragReleased)="onBorrowerDragReleased($event)"
                [cdkDragData]="borrower"
                [cdkDragDisabled]="borrower.isPrimary"
                class="borrower-container"
                [ngClass]="{ 'no-drag': borrower.isPrimary }"
              >
                <div class="drag-placeholder-borrower" *cdkDragPlaceholder>
                  <span>Borrower cannot be dropped here</span>
                </div>
                <div class="borrower-container" *cdkDragPreview>
                  <div class="d-flex align-items-center justify-content-between">
                    <div id="borrowerName">
                      <i class="fa-solid fa-grip fa-rotate-90"></i>
                      <span>{{ borrower.name }}</span>
                    </div>
                    <span id="switchText" class="small-bold-text switch-borrowers"></span>
                  </div>
                </div>
                <div class="d-flex align-items-center p-3">
                  <i class="fa-solid fa-grip fa-rotate-90 me-3" [ngClass]="{ disabled: borrower.isPrimary }"></i>
                  <span>{{ borrower.name }}</span>
                </div>
                @if (borrower.isPrimary) {
                  <span class="primary-button">Primary</span>
                }
                @if (!borrower.isPrimary) {
                  <p-button type="button" icon="pi pi-minus-circle" severity="danger" class="me-3" (click)="deleteBorrower($event, borrower.id)" />
                }
              </div>
            }
            @if (borrower.displayOrder === 1) {
              <div
                cdkDrag
                [cdkDragBoundary]="dragContainerRef()"
                (cdkDragStarted)="onBorrowerDragStarted($event)"
                (cdkDragDropped)="onBorrowerDragDropped($event)"
                (cdkDragEnded)="onBorrowerDragEnded($event)"
                (cdkDragEntered)="onBorrowerDragEntered($event)"
                (cdkDragExited)="onBorrowerDragExited($event)"
                (cdkDragReleased)="onBorrowerDragReleased($event)"
                [cdkDragData]="borrower"
                [cdkDragPreviewContainer]="'global'"
                class="borrower-container"
              >
                <div class="drag-placeholder-borrower" *cdkDragPlaceholder>
                  <span>Borrower cannot be dropped here</span>
                </div>
                <div class="borrower-container" *cdkDragPreview>
                  <div class="d-flex align-items-center justify-content-between">
                    <div id="borrowerName">
                      <i class="fa-solid fa-grip fa-rotate-90"></i>
                      <span>{{ borrower.name }}</span>
                    </div>
                    <span id="switchText" class="small-bold-text switch-borrowers"></span>
                  </div>
                </div>
                <div class="d-flex align-items-center p-3">
                  <i class="fa-solid fa-grip fa-rotate-90 me-3"></i>
                  <span>{{ borrower.name }}</span>
                </div>
                <div class="d-flex align-items-center">
                  @if (appIndex === 0 && !borrower.isPrimary) {
                    <p-button type="button" size="small" class="me-3" severity="contrast" (click)="makePrimary(borrower.id)" label="Make Primary" />
                  }
                  <p-button type="button" icon="pi pi-minus-circle" severity="danger" class="me-3" (click)="deleteBorrower($event, borrower.id)" />
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
  @if (deletedBorrowers?.length > 0) {
    <div class="application-card my-1 deleted-borrower-card">
      <div class="header">
        <div class="d-flex flex-column">
          Deleted Borrowers
          <span class="color-danger fs-sm fw-normal">Warning: All borrower data will be deleted, including residences, employers, and income.</span>
        </div>
      </div>
      <div
        class="content"
        cdkDropList
        cdkDropListLockAxis="y"
        cdkDropListData="deletedContainerId"
        (cdkDropListDropped)="onBorrowerDroppedInApplication($event)"
        (cdkDropListEntered)="onBorrowerEnteredApplication($event)"
        (cdkDropListExited)="onBorrowerExitedApplication($event)"
        (cdkDropListSorted)="onBorrowerMovingIntoPosition($event)"
      >
        @for (borrower of deletedBorrowers; track borrower) {
          <div
            cdkDrag
            [cdkDragPreviewContainer]="'global'"
            [cdkDragData]="borrower"
            [cdkDragBoundary]="dragContainerRef()"
            (cdkDragStarted)="onBorrowerDragStarted($event)"
            (cdkDragDropped)="onBorrowerDragDropped($event)"
            (cdkDragEnded)="onBorrowerDragEnded($event)"
            (cdkDragEntered)="onBorrowerDragEntered($event)"
            (cdkDragExited)="onBorrowerDragExited($event)"
            (cdkDragReleased)="onBorrowerDragReleased($event)"
            class="borrower-container"
          >
            <div class="d-flex align-items-center p-3">
              <i class="fa-solid fa-grip fa-rotate-90 me-3" [ngClass]="{ disabled: borrower.isPrimary }"></i>
              <span>{{ borrower.name }}</span>
            </div>
            <div class="drag-placeholder-borrower" *cdkDragPlaceholder>
              <span>Borrower cannot be dropped here</span>
            </div>
            <div class="borrower-container" *cdkDragPreview>
              <div class="d-flex align-items-center justify-content-between">
                <div id="borrowerName">
                  <i class="fa-solid fa-grip fa-rotate-90 mx-5"></i>
                  <span>{{ borrower.name }}</span>
                </div>
                <span id="switchText" class="small-bold-text switch-borrowers"></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (borrowers?.length > 1) {
    <div class="dialog-pt new application-card">
      <div class="content" cdkDropList cdkDropListLockAxis="y" cdkDropListData (cdkDropListDropped)="createNewApplicationWithBorrower($event)">
        <div class="borrower-container">
          <div class="d-flex align-items-center">
            <span>Drag and Drop a borrower here to create a new application</span>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<div class="dialog-button-container">
  <button pButton type="button" severity="secondary" (click)="reject()">Cancel</button>
  <button pButton type="button" class="fw-bold" (click)="accept()">Save</button>
</div>
